import { Component, EventEmitter, forwardRef, Inject, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import { TemplateLoaderService } from '../template-loader/template-loader.service';
import { TemplateLoadStatus } from '../template-loader/template-load-status';

/**
 * Loads the configured event-details template and reports whether content was actually rendered.
 */
@Component({
    selector: 'event-details-template',
    template: ''
})
export class EventDetailsTemplateComponent implements OnInit {

    @Input() templateName: string;

    @Input() thingDefinitionId: string;

    @Output() loadStatus = new EventEmitter<TemplateLoadStatus>();

    constructor(
        @Inject(forwardRef(() => ViewContainerRef)) private vcRef: ViewContainerRef,
        @Inject(forwardRef(() => TemplateLoaderService)) private templateLoaderService: TemplateLoaderService
    ) { }

    ngOnInit(): void {
        this.templateLoaderService.loadUserTemplateWithStatus(this.vcRef, this.templateName, this.thingDefinitionId)
            .then(status => this.loadStatus.emit(status));
    }
}
